import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ct-page-bad-data',
  templateUrl: './page-bad-data.component.html',
  styleUrls: ['./page-bad-data.component.css']
})
export class PageBadDataComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
